"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearAllMediaButton = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var Icon_1 = require("../../Icon");
var MediaContext_1 = require("../MediaContext");
function ClearAllMediaButton() {
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _js = mediaContext._js;
    var _a = (0, react_1.useDisclosure)(), isOpen = _a.isOpen, onOpen = _a.onOpen, onClose = _a.onClose;
    var cancelRef = React.useRef(null);
    function handleDelete() {
        mediaContext.deleteAllMediaItems();
        onClose();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(react_1.Button, { variant: "ghost", rightIcon: React.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faTrash }), onClick: onOpen, "data-feature-id": "media_manager_open_clear_media_confirmation_dialog" }, _js('Clear all media')),
        React.createElement(react_1.AlertDialog, { isOpen: isOpen, leastDestructiveRef: cancelRef, onClose: onClose },
            React.createElement(react_1.AlertDialogOverlay, null,
                React.createElement(react_1.AlertDialogContent, null,
                    React.createElement(react_1.AlertDialogHeader, { fontSize: "lg", fontWeight: "bold" }, _js('Clear all media')),
                    React.createElement(react_1.AlertDialogBody, null, _js("Are you sure? You can't undo this action afterwards.")),
                    React.createElement(react_1.AlertDialogFooter, null,
                        React.createElement(react_1.Button, { variant: "solid", ref: cancelRef, onClick: onClose }, _js('Cancel')),
                        React.createElement(react_1.Button, { variant: "solid", colorScheme: "red", onClick: handleDelete, ml: 3, "data-feature-id": "media_manager_clear_all_media" }, _js('Delete all media'))))))));
}
exports.ClearAllMediaButton = ClearAllMediaButton;
